import { useCallback, useState } from "react";

import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useNotification from "components/Notification/useNotification";
import { fetchApi } from "utils/baseFetcher";

type PremiumServiceButtonProps = {
  profile: any;
  children?: React.ReactNode;
  className?: string;
  parameters?: any;
};

const PremiumServiceButton = ({
  profile,
  children,
  className,
  parameters,
}: PremiumServiceButtonProps) => {
  const [sending, setSending] = useState(false);

  const { setNotification } = useNotification();

  const onClick = useCallback(() => {
    setSending(true);
    fetchApi("/nextjs/api/premium-services/request-trial", {
      method: "POST",
      body: JSON.stringify({
        profile: {
          id: profile.id,
          slug: profile.slug,
          name: profile.name,
          isCompany: profile.isCompany,
        },
        parameters,
      }),
    })
      .then(() => {
        setSending(false);
        setNotification(
          "Your request has been received. Our sales team will contact you with further details within 1-2 business days.",
          "success",
          7000
        );
      })
      .catch(() => {
        setSending(false);
        setNotification("Something went wrong!", "error");
      });
  }, [
    parameters,
    profile.id,
    profile.isCompany,
    profile.name,
    profile.slug,
    setNotification,
  ]);

  return (
    <button className={className} onClick={onClick} disabled={sending}>
      {sending && (
        <FontAwesomeIcon icon={faSpinner} className="animate-spin mr-[5px]" />
      )}
      {children || "Request Information/Trial"}
    </button>
  );
};

export default PremiumServiceButton;
